import React from 'react';
import Router from './Router';
import { theme } from './config/themes/worktango_theme';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './config/graphql/apolloClient';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={apolloClient}>
          <Router />
        </ApolloProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
